module.exports = __webpack_public_path__ + "img/youtube.d7a18131.svg";